module.exports = __webpack_public_path__ + "7bb76ed0cac661e339fa3d21c91534e1.svg";